import { connect } from 'react-redux';

import { StoreState } from '../../../../reducers';
import LinkPanel from '../../../../components/Editor/EditPanel/LinkPanel';
import { EditorType } from '../../constants';

const mapStateToProps = (state: StoreState, ownProps) => {
	const {
		editor: {
			pagesController: { spreads },
			type,
		},
		importManager: { byId },
	} = state;

	const { isUrlLinkOnly } = ownProps;

	return {
		...ownProps,
		spreads,
		isUrlLinkOnly: isUrlLinkOnly !== undefined ? isUrlLinkOnly : type === EditorType.HTML,
		isImporting: !!byId.linkPanel
	};
};

export default connect(mapStateToProps)(LinkPanel);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/EditPanel/LinkPanel/index.tsx